import { createFileRoute, redirect } from '@tanstack/react-router'
import { homeSearchSchema } from '../../src/schemas/routeSchemas'
import { fetchApi, type ApiResponse } from '../../src/hooks/common/useFetcher'
import { RiskDashboard } from '../../src/pages/Core/RiskDashboard'

export const Route = createFileRoute('/')({
  validateSearch: (search) => homeSearchSchema.parse(search),
  beforeLoad: async () => {
    const response = await fetchApi('getUserInfo') as ApiResponse
    if (response.status !== 0) throw redirect({ to: '/login' })
  },
  staticData: {
    englishAllowed: true,
    layout: 'menu',
  },
  component: RiskDashboard,
})
